import { render, staticRenderFns } from "./AppBarApplications.vue?vue&type=template&id=0f76fba5&"
import script from "./AppBarApplications.vue?vue&type=script&lang=js&"
export * from "./AppBarApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f76fba5')) {
      api.createRecord('0f76fba5', component.options)
    } else {
      api.reload('0f76fba5', component.options)
    }
    module.hot.accept("./AppBarApplications.vue?vue&type=template&id=0f76fba5&", function () {
      api.rerender('0f76fba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/AppBarApplications.vue"
export default component.exports